export const COOKIE_CITY = 'IDOCTOR_USER_CITY';
export const COOKIE_IP = 'IDOCTOR_USER_IP';
export const COOKIE_USER_AGENT = 'IDOCTOR_USER_AGENT';
export const COOKIE_LOCALE = 'NEXT_LOCALE';

export const SESSION_MOBILE_DOCTORS_STATE = 'doctors-mobile-state';
export const SESSION_MOBILE_DOCTORS_POSITION = 'doctors-mobile-position';
export const SESSION_LAST_BOOKING_TIMESTAMP = 'last_booking_timestamp';
